<template>
  <div>
    <v-container fluid>

      <Overlay :overlay="overlay"/>

      <v-row>
        <v-col cols="12">
          <v-card class="shadow rounded-lg">

            <v-card-title class="pa-0">
              <RolesTab/>
            </v-card-title>

            <v-divider/>

            <TableView :animators.sync="animators"
                       :is-loading="isLoading"
                       @delete="deleteAnimator($event)"
                       @refresh="getAnimators"
                       @change-status="changeStatus($event)"/>

          </v-card>
        </v-col>
      </v-row>

      <ConfirmDialog ref="confirmDialog"/>

    </v-container>
  </div>
</template>

<script>
import TableView from "@/views/animators/components/TableView.vue";
import {HTTP} from "@/http-common";
import RolesTab from "@/components/views/RolesTab.vue";

export default {
    components: {RolesTab, TableView},
    data() {
        return {
            overlay: false,
            isLoading: false,
            animators: [],
            filter: {}
        }
    },

    methods: {
        getAnimators() {
            this.isLoading = true
            HTTP.get('/animators', {
                params: {
                    filter: this.filter
                }
            }).then((res) => {
                this.isLoading = false
                this.animators = res.data.data
            }).catch(err => {
                this.isLoading = false
                console.log(err)
            })
        },
        async deleteAnimator(event) {
            if (await this.$refs.confirmDialog.open('', '', {
                icon: '',
                agreeText: '',
                color: 'red',
            })) {
                /**
                 * array
                 */
                let index = event[1]
                let id = event[0]

                this.overlay = true
                HTTP.delete('animators/' + id).then(() => {
                    this.animators.splice(index, 1)
                    this.overlay = false
                    this.$successMessage = 'Ce animateur a été supprimé avec succès.'
                }).catch(err => {
                    this.overlay = false
                    console.log(err)
                })
            }
        },
        async changeStatus(userId) {
            if (await this.$refs.confirmDialog.open('', 'Êtes-vous sûr de vouloir changer le statut de ce animateur ?', {
                icon: 'mdi-backup-restore',
                agreeText: 'Changer',
                color: 'orange',
            })) {
                this.overlay = true
                HTTP.post('/animators/' + userId + '/change-status').then(() => {
                    this.overlay = false
                    this.getAnimators()
                    this.$successMessage = 'Ce animateur a été modifié avec succès.'
                }).catch(err => {
                    this.overlay = false
                    console.log(err)
                })
            }
        },
        onPageChange() {
            this.getAnimators();
        },
    },
    created() {
        this.getAnimators()
    },
    watch: {
        view() {
            this.getAnimators();
        },
    },
}
</script>

<style scoped>
.v-tab {
    min-width: 30px;
}
</style>